"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.constructor");
var _utils = require("@/utils");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _newReports = require("@/api/bookSpace/newReports");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    blNo: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    newReportData: {
      type: Object,
      default: {}
    },
    newReportSearchForm: {
      type: Object,
      default: {
        spliteCombinType: '',
        confirmFlag: '',
        id: ''
      }
    },
    inputDisable: false
  },
  data: function data() {
    var _this = this;
    var validatebkNo = function validatebkNo(rule, value, callback) {
      var passwordRule = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      var passwordRule2 = /[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]/;
      var isValidTest = passwordRule.test(value);
      var isValidTest2 = passwordRule2.test(value);
      if (value === '') {
        callback(new Error(_this.$t('home.bkNoRequire')));
      }
      if (isValidTest) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      if (isValidTest2) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      callback();
    };
    var validateblNo = function validateblNo(rule, value, callback) {
      var passwordRule = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      var passwordRule2 = /[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]/;
      var isValidTest = passwordRule.test(value);
      var isValidTest2 = passwordRule2.test(value);
      if (value === '') {
        callback(new Error(_this.$t('home.blNoRequire')));
      }
      if (isValidTest) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      if (isValidTest2) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      callback();
    };
    return {
      loading: null,
      dialogTableDataForm: {
        dialogTableData: []
      },
      // dialogTableData: [],
      filterForm: {
        copyCount: undefined,
        bkType: '0'
      },
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: 1,
        name: 'Reshipment'
      }],
      form: {
        vesselCode: '',
        serviceLineCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 10
      },
      filterFormRules: {
        copyCount: [{
          required: true,
          message: this.$t('home.copyCountRequire'),
          trigger: 'blur'
        }]
      },
      tableRules: {
        bkNo: [{
          required: true,
          validator: validatebkNo,
          trigger: 'blur'
        }],
        // bkNo: [{required: true, message: this.$t('home.bkNoRequire'), trigger: 'blur'}],

        blNo: [{
          required: true,
          validator: validateblNo,
          trigger: 'blur'
        }]
        // blNo: [{required: true, message: this.$t('home.blNoRequire'), trigger: 'blur'}],
      },
      total: 0,
      tableData: [],
      etdDate: '',
      dialogTitle: '',
      addNumber: 0,
      bkBlNoDisabled: false // 拆单自动确认 自动出号时 提单号和订舱号不可编辑
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    // 拆弹自动确认的pod或者del以'PH'开头就禁用
    podAndDel: function podAndDel() {
      return this.newReportSearchForm.confirmFlag === 1 && this.newReportSearchForm.spliteCombinType === 0 && (this.newReportData.del.startsWith('PH') || this.newReportData.pod.startsWith('PH'));
    }
  }),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    deleteTableItem: function deleteTableItem(row) {
      if (this.dialogTableDataForm.dialogTableData.length <= 2) {
        this.$message({
          message: this.$t('home.deleteRequireLengh'),
          type: 'warning'
        });
        return;
      }
      var deleteIndex = -1;
      this.dialogTableDataForm.dialogTableData.map(function (item, index) {
        console.log('item.index,index', item.index, index);
        if (row.index == item.index) {
          deleteIndex = index;
        }
      });
      console.log('deleteIndex', deleteIndex);
      this.dialogTableDataForm.dialogTableData.splice(deleteIndex, 1);
    },
    opened: function opened() {
      console.log('this.newReportSearchForm.spliteCombinType', this.newReportSearchForm.spliteCombinType);
      console.log('this.newReportSearchForm.confirmFlag', this.newReportSearchForm.confirmFlag);
      if (this.newReportSearchForm.confirmFlag == 0) {
        if (this.newReportSearchForm.spliteCombinType == '0') {
          this.dialogTitle = this.$t('booking.bookingSplit.spliteTitle0');
        } else if (this.newReportSearchForm.spliteCombinType == '1') {
          this.dialogTitle = this.$t('booking.bookingSplit.spliteTitle1');
        } else if (this.newReportSearchForm.spliteCombinType == '3') {
          this.dialogTitle = this.$t('booking.bookingSplit.spliteTitle3');
        }
      } else {
        if (this.newReportSearchForm.spliteCombinType == '0') {
          this.dialogTitle = this.$t('booking.bookingSplit.spliteCombinType0');
        } else if (this.newReportSearchForm.spliteCombinType == '1') {
          this.dialogTitle = this.$t('booking.bookingSplit.spliteCombinType1');
        }
      }
      this.handleSearch();
      console.log('opened');
      console.log('newReportData', this.newReportData);
      console.log('newReportSearchForm', this.newReportSearchForm);
      console.log(' this.dialogTableDataForm.dialogTableData', this.dialogTableDataForm.dialogTableData);
    },
    inputBlur: function inputBlur() {
      if (this.filterForm.copyCount < 2 || this.filterForm.copyCount > 100) {
        this.$message({
          message: this.$t('home.numberLarge2'),
          type: 'warning'
        });
        return;
      }
      this.dialogTableDataForm.dialogTableData = [];
      if (this.filterForm.bkType == '0') {
        for (var i = 1; i <= this.filterForm.copyCount; i++) {
          this.dialogTableDataForm.dialogTableData.push({
            index: i - 1,
            bkNo: this.newReportData.bkNo + i + '',
            blNo: this.newReportData.blNo + i + '',
            vesselCode: this.newReportData.vesselCode,
            voyageNo: this.newReportData.voyageNo,
            pol: this.newReportData.pol,
            timeDate: this.newReportData.etd,
            isEdit: false,
            isBlBk: false,
            isAdd: true
          });
        }
      } else if (this.filterForm.bkType == '1') {
        for (var _i = 1; _i <= this.filterForm.copyCount; _i++) {
          // let letter = String.fromCharCode(64 + i);
          // console.log('letter',letter)
          var letter = this.getNumberToEnglish(_i);
          this.dialogTableDataForm.dialogTableData.push({
            index: _i - 1,
            bkNo: this.newReportData.bkNo + letter,
            blNo: this.newReportData.blNo + letter,
            vesselCode: this.newReportData.vesselCode,
            voyageNo: this.newReportData.voyageNo,
            pol: this.newReportData.pol,
            timeDate: this.newReportData.etd,
            isEdit: false,
            isBlBk: false,
            isAdd: true
          });
        }
      } else if (this.filterForm.bkType == '2') {
        for (var _i2 = 1; _i2 <= this.filterForm.copyCount; _i2++) {
          var _letter = this.getNumberToEnglish(_i2);
          this.dialogTableDataForm.dialogTableData.push({
            index: _i2 - 1,
            bkNo: this.newReportData.bkNo + '*' + _letter,
            blNo: this.newReportData.blNo + '*' + _letter,
            vesselCode: this.newReportData.vesselCode,
            voyageNo: this.newReportData.voyageNo,
            pol: this.newReportData.pol,
            timeDate: this.newReportData.etd,
            isEdit: false,
            isBlBk: false,
            isAdd: true
          });
        }
      }
    },
    getNumberToEnglish: function getNumberToEnglish(num) {
      var stringName = "";
      if (num > 0) {
        if (num >= 1 && num <= 26) {
          stringName = String.fromCharCode(64 + parseInt(num));
        } else {
          while (num > 26) {
            var count = parseInt(num / 26);
            var remainder = num % 26;
            if (remainder == 0) {
              remainder = 26;
              count--;
              stringName = String.fromCharCode(64 + parseInt(remainder)) + stringName;
            } else {
              stringName = String.fromCharCode(64 + parseInt(remainder)) + stringName;
            }
            num = count;
          }
          stringName = String.fromCharCode(64 + parseInt(num)) + stringName;
        }
      }
      console.log('stringName', stringName);
      return stringName;
    },
    addTableData: function addTableData() {
      console.log(this.newReportData.status, '2024.9.11');
      if (this.newReportData.status == 1) {
        var dialogTableDataItem = {
          index: this.addNumber++,
          bkNo: '',
          blNo: '',
          vesselCode: this.newReportData.vesselCode,
          voyageNo: this.newReportData.voyageNo,
          pol: this.newReportData.pol,
          timeDate: this.newReportData.etd,
          isEdit: false,
          isBlBk: true,
          isAdd: true
        };
        // 拆单自动确认弹窗修改
        if (this.newReportSearchForm.confirmFlag === 1 && this.newReportSearchForm.spliteCombinType === 0) {
          // 订舱号和提单号不可编辑
          this.bkBlNoDisabled = true;
        }
        this.dialogTableDataForm.dialogTableData.push(dialogTableDataItem);
      } else {
        this.dialogTableDataForm.dialogTableData.push({
          index: this.addNumber++,
          bkNo: '',
          blNo: '',
          vesselCode: this.newReportData.vesselCode,
          voyageNo: this.newReportData.voyageNo,
          pol: this.newReportData.pol,
          timeDate: this.newReportData.etd,
          isEdit: false,
          isBlBk: true,
          bookingHeadWebComId: '',
          isAdd: true
        });
      }
    },
    handleReset: function handleReset() {
      this.form = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 100
      };
    },
    handleSelectionChange: function handleSelectionChange(selections, row) {
      if (selections.length > 1) {
        var del_row = selections.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
        this.multipleSelection = selections;
      } else {
        this.multipleSelection = selections;
      }
    },
    handleClear: function handleClear() {
      this.filterForm.copyCount = undefined;
      this.dialogTableDataForm.dialogTableData = [];
    },
    closed: function closed() {
      this.handleClear();
    },
    handleSubimtDoApplyFt: function handleSubimtDoApplyFt() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _booking.doApplyFt)(_this2.form).then(function (res) {
            if (res.code) {
              _this2.$message.success(_this2.$t("home.ftapplyMessage"));
              _this2.$parent.ftDialogVisible = false;
            } else {
              _this2.$message.warning(res.errorMessages[0]);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleButtonClose: function handleButtonClose() {
      this.$emit('handleClose');
    },
    handleCancent: function handleCancent() {
      var _this3 = this;
      // bookingType2==1
      // blTYpe==0
      // this.newReportSearchForm.confirmFlag ==0
      console.log('this.newReportData', this.newReportData);
      console.log('this.newReportSearchForm.spliteCombinType', this.newReportSearchForm.spliteCombinType);
      if (this.newReportSearchForm.spliteCombinType == '0') {
        if (this.newReportData.bookingType2 !== '1' || this.newReportData.blType !== '0') {
          this.$message({
            message: this.$t('booking.bookingSplit.cancelWarning0'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.newReportSearchForm.spliteCombinType == '1') {
        if (this.newReportData.bookingType2 !== '1' || this.newReportData.blType !== '1') {
          this.$message({
            message: this.$t('booking.bookingSplit.cancelWarning1'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.newReportSearchForm.spliteCombinType == '3') {
        if (this.newReportData.separateType !== '1') {
          this.$message({
            message: this.$t('booking.bookingSplit.cancelWarning3'),
            type: 'warning'
          });
          return;
        }
      }
      this.loading = (0, _utils.load)();
      if (this.newReportSearchForm.confirmFlag == 1) {
        (0, _newReports.cancelData)(this.newReportSearchForm).then(function (res) {
          if (res.success) {
            _this3.$message({
              message: _this3.$t('home.cancelSuccess'),
              type: 'success'
            });
            _this3.$emit('handleGetTable');
          }
        }).finally(function () {
          _this3.loading.close();
        });
      } else {
        (0, _newReports.cancelSpliteData)(this.newReportSearchForm).then(function (res) {
          _this3.$message({
            message: _this3.$t('home.cancelSuccess'),
            type: 'success'
          });

          // this.form = res.data
          // this.form.vesselAndVoyage = this.form.vesselName + '/' + this.form.voyageNo + '/' + this.form.voyageLeg
          _this3.$emit('handleGetTable');
        }).finally(function () {
          _this3.loading.close();
        });
      }
    },
    handleApply: function handleApply() {
      var _this4 = this;
      this.$refs.tableFormRef.validate(function (valid) {
        if (valid) {
          if (_this4.dialogTableDataForm.dialogTableData.length < 2) {
            _this4.$message({
              message: _this4.$t('home.deleteRequireLengh'),
              type: 'warning'
            });
            return;
          }
          for (var i = 0; i < _this4.dialogTableDataForm.dialogTableData.length; i++) {
            for (var j = 0; j < _this4.dialogTableDataForm.dialogTableData.length; j++) {
              if (_this4.dialogTableDataForm.dialogTableData[i].bkNo === _this4.dialogTableDataForm.dialogTableData[j].bkNo && i !== j) {
                _this4.$message({
                  message: _this4.$t('booking.bookingSplit.repeatWarning1') + '' + _this4.dialogTableDataForm.dialogTableData[i].bkNo + ' ' + _this4.$t('booking.bookingSplit.repeatWarning2'),
                  type: 'warning'
                });
                return;
              }
              if (_this4.dialogTableDataForm.dialogTableData[i].blNo === _this4.dialogTableDataForm.dialogTableData[j].blNo && i !== j) {
                _this4.$message({
                  message: _this4.$t('booking.bookingSplit.repeatWarningBlNo1') + ' ' + _this4.dialogTableDataForm.dialogTableData[i].blNo + ' ' + _this4.$t('booking.bookingSplit.repeatWarningBlNo2'),
                  type: 'warning'
                });
                return;
              }
            }
          }
          var data = _this4.dialogTableDataForm.dialogTableData;
          _this4.loading = (0, _utils.load)();
          if (_this4.newReportSearchForm.confirmFlag === 0) {
            var params = {
              spliteCombinType: _this4.newReportSearchForm.spliteCombinType,
              bookingHeadWebComId: _this4.newReportSearchForm.id,
              data: data
            };
            (0, _newReports.getSpliteData)(params).then(function (res) {
              _this4.$message({
                message: _this4.$t('home.applySuccess'),
                type: 'success'
              });
              // this.form = res.data
              // this.form.vesselAndVoyage = this.form.vesselName + '/' + this.form.voyageNo + '/' + this.form.voyageLeg
              _this4.$emit('handleGetTable');
            }).finally(function () {
              _this4.loading.close();
            });
          } else {
            var _params = {
              spliteCombinType: _this4.newReportSearchForm.spliteCombinType,
              confirmFlag: _this4.newReportSearchForm.confirmFlag,
              bookingHeadWebComId: _this4.newReportSearchForm.id,
              data: data
            };
            (0, _newReports.getSpliteData)(_params).then(function (res) {
              _this4.$message({
                message: _this4.$t('home.applySuccess'),
                type: 'success'
              });
              // this.form = res.data
              // this.form.vesselAndVoyage = this.form.vesselName + '/' + this.form.voyageNo + '/' + this.form.voyageLeg
              _this4.$emit('handleGetTable');
            }).catch(function (err) {
              // this.$emit('handleGetTable')
            }).finally(function () {
              _this4.loading.close();
            });
          }
        } else {
          _this4.loading.close();
          return false;
        }
      });
    },
    handleSearch: function handleSearch() {
      var _this5 = this;
      // if (this.newReportData.status == 1) {
      //   return
      // }
      (0, _newReports.getLoadSpliteDataMap)(this.newReportSearchForm).then(function (res) {
        _this5.dialogTableDataForm.dialogTableData = [];
        res.data.map(function (item, index) {
          _this5.dialogTableDataForm.dialogTableData.push({
            index: index,
            bkNo: item.bkNo,
            blNo: item.blNo,
            vesselCode: item.vessel,
            voyageNo: item.voyage,
            pol: item.pol,
            bookingHeadWebComId: item.bookingHeadWebComId,
            timeDate: _this5.newReportData.etd,
            isEdit: false,
            isBlBk: false
          });
        });
        if (_this5.dialogTableDataForm.dialogTableData.length > 0) {
          _this5.inputDisable = true;
          _this5.filterForm.copyCount = _this5.dialogTableDataForm.dialogTableData.length;
        }

        // this.form = res.data
        // this.form.vesselAndVoyage = this.form.vesselName + '/' + this.form.voyageNo + '/' + this.form.voyageLeg
      });
    }
  }
};